import { GridRowId, GridValidRowModel } from '@mui/x-data-grid-pro';
import { Permission } from '@procureai/permissions';
import { usePermissions } from '@procureai/permissions-ui';
import { Union } from 'ts-toolbelt';

import { useDataGridContext } from '../../hooks/useDataGridContext';
import { getRowId } from '../../util/internalRowIds';
import { PriorityRating } from '~/components/PriorityRating/PriorityRating';
import { eventStopPropagation } from '~/util/function/eventStopPropagation';

export interface PriorityCellContext {
  onPriorityChange: (rowId: GridRowId, priority: number) => Promise<void>;
}

export type PriorityCellValue = Union.Nullable<number>;

interface PriorityCellProps<R extends GridValidRowModel = any> {
  value: PriorityCellValue;
  row: R;
  needsPermission?: Permission;
}

export const PriorityCell = <R extends GridValidRowModel = any>({
  value,
  row,
  needsPermission,
}: PriorityCellProps<R>) => {
  const { hasPermission } = usePermissions();
  const { onPriorityChange } = useDataGridContext<PriorityCellContext>();
  if (!onPriorityChange) {
    throw new Error('PriorityCell: DataGridContextProvider must provide a onPriorityChange method');
  }
  return (
    <PriorityRating
      value={value || null}
      onClick={eventStopPropagation}
      disabled={needsPermission && !hasPermission(needsPermission)}
      onChange={(_event, value) => {
        onPriorityChange(getRowId(row), value || 0);
      }}
    />
  );
};
